class InfoBoxService {
    /*@ngInject*/
    constructor($rootScope) {
        this.$rootScope = $rootScope;
    }

    showYourSizeNotLoggedInInfoBox() {
        this.$rootScope.$broadcast('yourSizeNotLoggedInInfoBoxVisible');
    }
}

export default InfoBoxService;
